<template>
  <div>
    <div>
      <span :class="className">{{signInStatus}}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-appointment-green {
  color: #009145;
}
.cs-appointment-red {
  color: #e1272d;
}
</style>

<script>
export default {
  props: {
    data: {},
  },
  data() {
    return {
      signInStatus: "",
      className: "",
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data) {
        this.signInStatus = this.data.SignInStatus;
        if (this.data.IsWatchApproved){
          this.className = "cs-appointment-green";
        }else{
          this.className = "";
        }
      }
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/appointmentSignInStatusCell.vue